import React from "react"
import { Outlet, useNavigate } from "react-router-dom"

import { CurrentUser, CurrentOrg, CurrentOrgId } from "../lib/store"
import { AUTH_ORGANIZATION_ID } from "../lib/api"

function CurrentOrganization() {
  const navigate = useNavigate()
  const [currentUser] = CurrentUser.useState()
  const [org] = CurrentOrg.useState()
  const [orgId] = CurrentOrgId.useState()
  React.useEffect(() => {
    // Logout sets CurrentUser to {} — empty object is still truthy; require identity fields.
    if (!currentUser?.email && !currentUser?.username) {
      return
    }

    const orgs = currentUser.organizations
    // Wait until /users/self has resolved organizations (do not treat undefined like [])
    if (!Array.isArray(orgs)) {
      return
    }

    if (orgs.length === 0) {
      console.log("No organizations — redirecting to create flow")
      navigate("/organizations/create", { replace: true })
      return
    }

    if (!orgId) {
      let sessionOrgId = sessionStorage.getItem(AUTH_ORGANIZATION_ID)
      if (sessionOrgId) {
        const sessionMatch = orgs.find((o) => o.id === sessionOrgId)
        if (sessionMatch) {
          CurrentOrgId.setValue(sessionOrgId)
          return
        }
        sessionStorage.removeItem(AUTH_ORGANIZATION_ID)
      }

      const firstId = orgs[0].id
      sessionStorage.setItem(AUTH_ORGANIZATION_ID, firstId)
      CurrentOrgId.setValue(firstId)
      return
    }

    const matching = orgs.find((o) => o.id === orgId)
    if (!matching) {
      console.log("Session org not in user org list — resetting to first org")
      const firstId = orgs[0].id
      sessionStorage.setItem(AUTH_ORGANIZATION_ID, firstId)
      CurrentOrgId.setValue(firstId)
      return
    }

    const existingStripe = CurrentOrg.getValue()?.settings?.stripe || {}
    // Use the current user's own subscription as the org plan — it's the
    // authoritative source and avoids picking up stale plans from inactive members.
    const userPlan = currentUser?.settings?.stripe?.product_name
    CurrentOrg.setValue({
      ...matching,
      settings: {
        ...(matching.settings || {}),
        stripe: {
          ...existingStripe,
          ...(matching.settings?.stripe || {}),
          ...(userPlan ? { product_name: userPlan } : {}),
        },
      },
    })
  }, [currentUser, orgId, navigate])

  if ((!currentUser?.email && !currentUser?.username) || !org) return <></>
  return <Outlet />
}

export default CurrentOrganization
